import styled from 'styled-components'

export const AuditCell = styled.div`
  display: flex;
  align-items: center;
  min-height: 40px;
`

/**
 * The care plan audit control for one row.
 *
 * Default / in-progress / blocked / ready all share the filled primary button
 * (sparkles + solid fill). A finished report still opens on click; only the
 * tooltip differs. The muted `ready` variant is unused — kept for typing only.
 *
 * The disabled state (no care plan yet, or allowance spent) keeps the filled
 * shape at low opacity, so the row still shows where the audit lives.
 */
export const AuditButton = styled.button<{ variant?: 'idle' | 'ready' }>`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 38px;
  padding: 0 16px;
  border-radius: var(--careco-rounded-sm, 8px);
  border: 1px solid transparent;
  font-family: var(--careco-font, 'Lato', sans-serif);
  font-size: 14px;
  font-weight: 600;
  line-height: 1.4;
  cursor: pointer;
  white-space: nowrap;
  transition: background 140ms ease, box-shadow 160ms ease, transform 140ms ease,
    border-color 140ms ease, color 140ms ease;

  background: ${({ variant }) => (variant === 'ready' ? 'var(--careco-primary-light)' : 'var(--careco-primary)')};
  color: ${({ variant }) => (variant === 'ready' ? 'var(--careco-primary)' : '#ffffff')};
  box-shadow: ${({ variant }) => (variant === 'ready' ? 'none' : '0 1px 2px rgba(15, 61, 60, 0.14)')};

  & svg {
    display: block;
    width: 15px;
    height: 15px;
    flex-shrink: 0;
  }

  /* SparklesIcon paints its paths with a fixed fill; on the filled button it
     has to follow the button's own text colour. */
  ${({ variant }) => variant !== 'ready' && '& svg path { fill: currentColor; }'}

  &:hover:not(:disabled) {
    background: ${({ variant }) => (variant === 'ready' ? 'var(--careco-primary-light)' : 'var(--careco-primary-hover)')};
    box-shadow: ${({ variant }) => (variant === 'ready' ? 'none' : '0 6px 18px rgba(15, 61, 60, 0.24)')};
    transform: ${({ variant }) => (variant === 'ready' ? 'none' : 'translateY(-1px)')};
    border-color: ${({ variant }) => (variant === 'ready' ? 'var(--careco-primary)' : 'transparent')};
  }

  &:focus-visible {
    outline: 2px solid var(--careco-primary);
    outline-offset: 2px;
  }

  &:disabled {
    opacity: 0.45;
    cursor: default;
    box-shadow: none;
    transform: none;
    pointer-events: none;
  }
`
